import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-tag-list',
	templateUrl: './tag-list.component.html',
	styleUrls: ['./tag-list.component.css'],
})
export class TagListComponent extends ListComponent {
	protected apiUrl = 'tag';
	protected apiType = 'bag';
	codebook;
	title: string;
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'tag', name: 'Tag (Hasło klucz)' },
	];

	filters = {
		limit: 9999,
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/7/', (result, error) => {
			this.codebook = result;

			this.title = `Słowniki -> ${this.codebook.name}`;
			this.loadData();
		});
	}
}
